module.exports = __webpack_public_path__ + "img/game-logo.18ace0a6.png";